// eslint-disable-next-line no-use-before-define
import React from 'react';
import { PublicLevelResult } from '$/services/api_service/apis/room.api';
import { SessionContext } from '../session_context';
import { formatChallengeTime, LeaderboardResults } from '../work_view/views/components/leaderboard-results.view';
import '../work_view/projects-menu.scss';

export const PublicResultView = () => {
  const { sessionService } = React.useContext(SessionContext) as any;
  const [result, setResult] = React.useState<PublicLevelResult>(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState('');
  const [revision, setRevision] = React.useState(0);
  const id = window.location.pathname.split('/')[2];
  React.useEffect(() => {
    let active = true;
    setResult(null); setLoading(true); setError('');
    sessionService.apiService.roomApi.publicResult(id).then((response: any) => {
      if (!response.data?.result) throw new Error('Result unavailable');
      if (active) setResult(response.data.result);
    }).catch((failure: any) => {
      if (active) setError(failure.status === 404 ? 'This result is private or no longer available.' : 'This result could not be loaded. Please try again.');
    }).finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [sessionService, id, revision]);
  React.useEffect(() => {
    const refresh = () => { if (!document.hidden) setRevision((value) => value + 1); };
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', refresh);
    return () => { window.removeEventListener('focus', refresh); document.removeEventListener('visibilitychange', refresh); };
  }, []);
  return (
    <main className="projects-menu public-result-page">
      <header className="projects-navigation">
        <div>
          <small>Kainundrum</small>
          <h1>Public level result</h1>
        </div>
        <button type="button" className="btn btn-outline-secondary" disabled={loading} onClick={() => setRevision((value) => value + 1)}>Refresh</button>
      </header>
      <div className="projects-panel results-content">
        {loading && <p role="status">Loading result...</p>}
        {error && <p role="alert">{error}</p>}
        {result && (
        <>
          <section className="public-result-summary">
            <h2>{result.playerName}</h2>
            <p>{result.workName}</p>
            <dl>
              <div>
                <dt>Best time</dt>
                <dd>{formatChallengeTime(result.fastest)}</dd>
              </div>
              <div>
                <dt>Coding score</dt>
                <dd>{result.coder ?? '\u2014'}</dd>
              </div>
            </dl>
          </section>
          <LeaderboardResults scores={result.leaderboard} loading={false} error="" />
        </>
        )}
        <p className="result-contact">
          <a href="/">Explore Kainundrum</a>
          {' '}
          ·
          {' '}
          <a href="mailto:support@kaiseducation.com">Contact support</a>
        </p>
      </div>
    </main>
  );
};
